module.exports = __webpack_public_path__ + "47e5e6bdb15c14a01300ed5df9ddcd1f.png";